import React from 'react'
import SplitMachineStop from '../features/splitMachineStop'

export default function SplitMachineStopPage() {
  return (
    <SplitMachineStop />
  )
}
